import React, {useState} from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import Hidden from '@mui/material/Hidden';
import { Field, reduxForm } from 'redux-form';
import Button from '@mui/material/Button';
import { connect, useDispatch } from 'react-redux';
import FormControl from '@mui/material/FormControl';
import Paper from '@mui/material/Paper';
import brand from 'enl-api/dummy/brand';
import logo from 'enl-images/logo.svg';
import { injectIntl } from 'react-intl';
import { closeMsgAction } from 'enl-redux/actions/authActions';
import { TextFieldRedux } from './ReduxFormMUI';
import MessagesForm from './MessagesForm';
import useStyles from './user-jss';
import logo_purple from './Backoffice_logo/logo_purple.svg';
import axios from 'axios';
import { loginWithEmail } from '../../redux/actions/authActions';
import config from '../../config/config';
import {Box, Modal} from "@mui/material";
import BtnIcons from "../../api/images/btnIcons";

const required = (value) => (value === null ? 'Required' : undefined);
const email = (value) =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? 'Invalid email' : undefined;

// const LinkBtn = React.forwardRef(function LinkBtn(props, ref) {
//   // eslint-disable-line
//   return <NavLink to={props.to} {...props} innerRef={ref} />; // eslint-disable-line
// });

function LoginForm(props) {
  const { handleSubmit, messagesAuth, closeMsg } = props;

  const { classes } = useStyles();

  const apiURL = config.API_URL;
  const logoStyle = {
    display: 'flex',
    justifyContent: 'center',
  };
  const formStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  };

  const [isOpenConfirmModal, setIsOpenConfirmModal] = useState(false);

  const dispatch = useDispatch();

  const validateEmail = (value) => {
    // Regular expression to validate email format
    const emailRegex = /^[-0-9A-Za-z!#$%&'*+/=?^_`{|}~.]+@[-0-9A-Za-z!#$%&'*+/=?^_`{|}~]+[.]{1}[0-9A-Za-z]/;
    return emailRegex.test(value);
  };

  const handleLoginBtn = () => {
    const emailAddr = document.getElementsByName('email')[0].value;
    const pwdInput = document.getElementsByName('password')[0].value;

    const correctAddr = validateEmail(emailAddr);

    if (correctAddr) {
        console.log("dispatch")
      dispatch(loginWithEmail(emailAddr, pwdInput));
    } else {
      alert('이메일 형식을 확인하세요.');
    }
  };

  const findPwd = () => {
    const emailAddr = document.getElementsByName('email')[0].value;
    console.log('emailAddr: ', emailAddr);

    console.log("findPwd!");
    setIsOpenConfirmModal(false);

    const correctAddr = validateEmail(emailAddr);

    if (correctAddr) {
      axios
        .post(
          `${apiURL}api/ManagerAccount/FindPassword`, // 서버상관 X
          { email: emailAddr },
          {
            headers: {
              'Content-Type': 'application/json',
              'CF-Access-Client-Id': '4210cff703e83401a76ff3cf83304054.access',
              'CF-Access-Client-Secret': '2487d06c0681e7b76d59427be09e21473f987a4d11970ae2dd85d6cd1d2bd825',
            },
            responseType: 'blob', // Set the response type to 'blob'
          },
        )
        .then((response) => {
          console.log('response: ', response);
          if (response.status === 200) {
            alert(`${emailAddr}에 대한 패스워드 초기화 요청을 성공했습니다.`);
          }
        })
        .catch((error) => {
          console.error('Error: ', error);
        });
    } else {
      alert('메일 형식을 확인해주세요.');
    }
  };

  return (
    <Paper className={classes.sideWrap}>
      {/*<Hidden mdUp>*/}
      {/*  <div className={classes.headLogo}>*/}
      {/*    <NavLink to="/" className={classes.brand}>*/}
      {/*      <img src={logo} alt={brand.name} />*/}
      {/*      {brand.name}*/}
      {/*    </NavLink>*/}
      {/*  </div>*/}
      {/*</Hidden>*/}

        {messagesAuth && (
            <MessagesForm
                variant="error"
                className={classes.msgUser}
                message={messagesAuth}
                onClose={closeMsg}
            />
        )}
      <section
          // className={classes.pageFormSideWrap}
          style={formStyle}>


        <div style={logoStyle}>
          <img src={logo_purple}/>
          <p
              style={{
                fontWeight: 700,
                fontSize: '20px',
                lineHeight: '28px',
                color: '#787878',
                marginTop: '20px',
              }}
          >
            Admin
          </p>
        </div>

          <div className="spaceDiv10"/>
        <form onSubmit={handleSubmit} style={{width: '360px'}}>
          <div>
            <FormControl variant="standard" className={classes.formControl}>
              <Field
                  name="email"
                  component={TextFieldRedux}
                  placeholder="아이디"
                  required
                  validate={[required, email]}
                  className={classes.field}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handleLoginBtn();
                    }
                  }}
              />
            </FormControl>
          </div>
          <div>
            <FormControl variant="standard" className={classes.formControl}>
              <Field
                  name="password"
                  component={TextFieldRedux}
                  type="password"
                  placeholder="비밀번호"
                  required
                  validate={required}
                  className={classes.field}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handleLoginBtn();
                    }
                  }}
              />
            </FormControl>
          </div>


          {/*<div className={classes.btnArea}>*/}
            <button
                style={{width:'100%', fontSize : 14, fontWeight: 400, height : 40,}}
                // variant="contained"
                // fullWidth
                onClick={() => {
                  handleLoginBtn();
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleLoginBtn();
                  }
                }}
            >
              로그인
            </button>
          {/*</div>*/}

            <div className="spaceDiv10"/>
            <div className="spaceDiv10"/>

        </form>
        <p
            style={{
              fontSize: 14,
              fontWeight: 400,
              color: '#787878',
              float: 'right',
              cursor: 'pointer',
            }}
            onClick={() => {setIsOpenConfirmModal(true)}}
        >
          비밀번호 찾기
        </p>
      </section>

        <Modal
            open={isOpenConfirmModal}
            onClose={() => setIsOpenConfirmModal(false)}
            aria-labelledby="confirm-modal-title"
            aria-describedby="confirm-modal-description"
        >
            <Box className="modalBox">
                <div className="modalTitle" style={{ display: "flex", alignItems: 'center', justifyContent: "space-between"}}>
                    비밀번호 초기화
                    <img
                        src={BtnIcons.closeIcon}
                        onClick={() => setIsOpenConfirmModal(false)}
                        style={{ cursor: 'pointer', float: 'right' }}
                        alt="Close"
                    />
                </div>
                <div className="sectionLine" />
                <div className="spaceDiv10"/>
                <div className="descText">{`기존 비밀번호로 로그인할 수 없게 됩니다.\n비밀번호 초기화를 요청하시겠습니까?`}</div>
                <div className="spaceDiv10"/>
                <div className="rightBtn padding">
                    <button className="cancelBtn purple" onClick={() => setIsOpenConfirmModal(false)}>
                        취소
                    </button>
                    <button className="endBtn error" onClick={findPwd}>
                        확인
                    </button>
                </div>
            </Box>
        </Modal>
    </Paper>
  );
}

LoginForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  intl: PropTypes.object.isRequired,
  messagesAuth: PropTypes.string,
  loading: PropTypes.bool,
  closeMsg: PropTypes.func.isRequired,
};

LoginForm.defaultProps = {
  messagesAuth: PropTypes.func.isRequired,
  loading: false,
};

const LoginFormReduxed = reduxForm({
  form: 'loginForm',
  enableReinitialize: true,
})(LoginForm);

const mapDispatchToProps = {
  closeMsg: closeMsgAction,
};

const mapStateToProps = (state) => ({
  messagesAuth: state.authReducer.message,
  loading: state.authReducer.loading,
});

const LoginFormMapped = connect(mapStateToProps, mapDispatchToProps)(LoginFormReduxed);

export default injectIntl(LoginFormMapped);
